import axiosInstance from '../axios/axiosInstance';

export function firstApiError(error) {
    const data = error?.response?.data;
    const errors = data?.errors;
    if (errors && typeof errors === 'object') {
        const first = Object.values(errors).flat().find(Boolean);
        if (first) return String(first);
    }
    return data?.message || null;
}

export function apiFieldErrors(error) {
    const errors = error?.response?.data?.errors;
    if (!errors || typeof errors !== 'object') return {};
    const mapped = {};
    Object.entries(errors).forEach(([key, value]) => {
        mapped[key] = Array.isArray(value) ? value[0] : value;
    });
    return mapped;
}

function unwrapItem(payload) {
    const data = payload?.data;
    if (data && !Array.isArray(data) && (data.id != null || data.guardians)) return data;
    return data ?? payload;
}

export function unwrapLead(payload) {
    return unwrapItem(payload);
}

export async function fetchLeads(query = {}) {
    const params = { page: query.page ?? 1, per_page: query.perPage ?? 15 };
    if (query.name) params.name = query.name;
    if (query.phone) params.phone = query.phone;
    if (query.status && query.status !== 'all') params.status = query.status;
    if (query.createdAt) params.created_at = query.createdAt;
    const response = await axiosInstance.get('/call_center/leads', { params });
    const body = response.data ?? {};
    const items = Array.isArray(body.data) ? body.data : [];
    const meta = body.meta ?? {};
    return {
        items,
        pagination: {
            current: Number(meta.current_page ?? params.page) || 1,
            pageSize: Number(meta.per_page ?? params.per_page) || 15,
            total: Number(meta.total ?? items.length) || 0,
        },
    };
}

export async function createLead(body) {
    const response = await axiosInstance.post('/call_center/leads', body);
    return unwrapLead(response.data);
}

export async function updateLead(id, body) {
    const response = await axiosInstance.patch(`/call_center/leads/${id}`, body);
    return unwrapLead(response.data);
}

export async function fetchLead(id) {
    const response = await axiosInstance.get(`/call_center/leads/${id}`);
    return unwrapLead(response.data);
}

export async function fetchGuardians(leadId) {
    const response = await axiosInstance.get(`/call_center/leads/${leadId}/guardians`);
    const data = response.data?.data ?? response.data;
    return Array.isArray(data) ? data : [];
}

export async function createGuardian(leadId, body) {
    const response = await axiosInstance.post(`/call_center/leads/${leadId}/guardians`, body);
    return unwrapItem(response.data);
}

export async function updateGuardian(leadId, id, body) {
    const response = await axiosInstance.patch(`/call_center/leads/${leadId}/guardians/${id}`, body);
    return unwrapItem(response.data);
}

export async function deleteGuardian(leadId, id) {
    await axiosInstance.delete(`/call_center/leads/${leadId}/guardians/${id}`);
}

export function normalizeGuardianPhone(value) {
    return String(value || '').replace(/[\s()]/g, '');
}
